export const ru = {
    accept: 'Добавить',
    cancel: 'Отмена',
    'error-text': 'Повторите попытку позже',
    'imageAd-help-text':
        'Выберите больше одного изображения, чтобы создать несколько объявлений сразу',
    'textImageAd-help-text': 'Выберите изображение для объявления',
    title: 'Галерея'
};
